import loadable from '@cap/share/src/utils/loadable';
import { IRouteProps } from '@cap/ssr-common-utils/types';
import { PC_PATH } from '@cap/share/src/utils/navigation/index';
import homePage from '@/pages/home';
// import { getBaseName, HomeRoute } from './route';
import { courseDetailRouters } from '@/pages/courseDetail/router';

const routes: IRouteProps[] = [
  {
    path: PC_PATH.CourseCenter,
    name: 'course-center',
    component: loadable(() => import('@/pages/courseCenter')),
  },
  {
    path: PC_PATH.ViewAll,
    name: 'view-all',
    component: loadable(() => import('@/pages/viewAllPages/viewAll')),
  },
  {
    path: PC_PATH.LearningHistory,
    name: 'learning-history',
    component: loadable(() => import('@/pages/viewAllPages/learningHistory')),
  },
  {
    path: PC_PATH.SearchCourses,
    name: 'search-courses',
    component: loadable(() => import('@/pages/viewAllPages/searchCourses')),
  },

  ...courseDetailRouters,
  {
    path: PC_PATH.Home,
    name: 'home',
    component: homePage,
  },
  // {
  //   ...HomeRoute,
  //   component: homePage,
  // },
];

export default routes;

// const newRoutes = [
//   ...routes.map((route) => {
//     const basename = getBaseName();
//     return { ...route, path: `${basename}${route.path}` };
//   }),
// ];

// export default newRoutes;
